import React from 'react';
import { KompisToast } from '@inter-ikea-kompis/react-components';
import { useIntl } from 'react-intl';
import { InfoMessage } from 'ducks/layout';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

type Props = {
  visible: boolean;
  onClose?: () => void;
  toastMessage: InfoMessage | undefined;
};

function Toast(props: Props) {
  const { formatMessage } = useIntl();

  const onActionClicked = () => {
    props.toastMessage?.action?.onClick?.();
    props.onClose?.();
  };

  return (
    <>
      {props.visible && props.toastMessage && (
        <KompisToast
          data-testid="toast-component"
          visible={props.visible}
          theme={SkapaTheme}
          onClose={props.onClose}
          actionLabel={
            props.toastMessage.action && formatMessage({ id: props.toastMessage.action?.text })
          }
          onActionClick={onActionClicked}
          label={
            props.toastMessage &&
            formatMessage({ id: props.toastMessage.message }, props.toastMessage.params)
          }
        />
      )}
    </>
  );
}

export default Toast;
